export const increamentData = [
  { name: 'Page A', pv: 200 },
  { name: 'Page B', pv: 1200 },
  { name: 'Page C', pv: 600 },
  { name: 'Page D', pv: 1600 },
  { name: 'Page D', pv: 1000 },
  { name: 'Page H', pv: 2260 },
  { name: 'Page K', pv: 800 },
];